var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-btn'),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"lg":"8"}},[_c('v-card',{staticClass:"card--shadow"},[_c('he-form',{on:{"emitData":_vm.createHe}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }